<div class="container-input-select" *ngIf="!isMultiple; else multipleSelect">
  <mat-label class="container-input-select__label" *ngIf="title">{{ translatedTitle }}</mat-label>
  <mat-form-field appearance="outline">
    <mat-select
      [disabled]="disabled"
      (selectionChange)="onInput($event)"
      [value]="value"
      [placeholder]="placeholder"
    >
      <mat-option [value]="placeholder" *ngIf="placeholder && !isMultiple" disabled>{{ translatedPlaceholder }}</mat-option>
      <mat-option *ngFor="let option of optionsList" [value]="option.value">
        {{ getOptionText(option) }}
      </mat-option>
    </mat-select>
  </mat-form-field>
</div>

<ng-template #multipleSelect>
  <div class="container-input-select">
    <mat-label class="container-input-select__label" *ngIf="title">{{ translatedTitle }}</mat-label>
    <mat-form-field class="multiple-select" appearance="fill">
      <mat-select
        multiple
        [disabled]="disabled"
        (selectionChange)="onSelectChange($event)"
        [value]="selectedValues"
        [placeholder]="placeholder"
      >
        <mat-select-trigger>
          <mat-chip-listbox>
            <mat-chip *ngFor="let option of selectedOptions" [removable]="true" (removed)="removeOption(option.value)">
              {{ getOptionText(option) }}
              <button matChipRemove>
                <mat-icon>cancel</mat-icon>
              </button>
            </mat-chip>
          </mat-chip-listbox>
        </mat-select-trigger>

        <mat-option *ngFor="let option of optionsList" [value]="option.value">
          {{ getOptionText(option) }}
        </mat-option>
      </mat-select>
    </mat-form-field>
  </div>
</ng-template>
